import React from  "react"
import Layout from "../Layout"
import Contact from "../Contact";
import Summary2020 from "../Summary2020"

const IndexPage = ({ lang }) => (
  <Layout lang={lang}>
    <Summary2020 lang={lang} />
    <Contact lang={lang} />
  </Layout>
)

export default IndexPage